export default {
  status: {
    pending: 'Esperando el DNS',
    verified: 'Activo',
    failed: 'Acción necesaria',
  },
  summary: {
    preparing:
      'Se están preparando los registros para {{host}}. Aparecen aquí en unos 15 minutos — o enseguida después de pulsar Comprobar de nuevo.',
    pending:
      'Esperando los registros DNS de abajo. Suele tardar unos minutos y puede llevar hasta 48 horas — seguimos comprobándolo por nuestra cuenta.',
    certificate_pending:
      'Los registros están en su sitio. Se está emitiendo el certificado para {{host}} — suele tardar unos minutos.',
    verified: 'La tienda online está activa en {{host}}.',
    serving: 'La tienda online está activa en {{serving_host}}, pero {{host}} todavía no la abre.',
    apex_elsewhere:
      'El registro A en @ todavía no apunta a la tienda. Si {{host}} muestra un sitio web que debe quedarse ahí, deja @ como está — la tienda funciona en {{serving_host}}. Si no, añade el registro A de abajo.',
    apex_held:
      '{{host}} lo usa otro sitio web en Vercel. Para que {{host}} también abra la tienda, primero quita el dominio de ese sitio web.',
    regressed:
      '{{host}} funcionaba, pero un registro de abajo ha dejado de comprobarse. Corrígelo en el proveedor de DNS y pulsa Comprobar de nuevo.',
    record_elsewhere:
      'Un registro de abajo apunta a otro sitio. Cámbialo en el proveedor de DNS por el valor indicado y pulsa Comprobar de nuevo.',
    records_missing:
      'Los registros de abajo siguen sin encontrarse después de 48 horas. Comprueba que se guardaron para {{zone}}, en el proveedor que gestiona su DNS. Si ese proveedor no permite el cambio, puede que el dominio esté bloqueado allí.',
    certificate: {
      ownership_proof_required:
        '{{host}} también está conectado a otra cuenta de Vercel, así que el restaurante tiene que demostrar que el dominio es suyo.',
      held_by_another_project:
        '{{host}} todavía lo usa otro sitio web en Vercel, así que la tienda aún no puede usarlo.',
      dns_correct_but_unconfigured: 'Los registros son correctos, pero otra cosa en {{host}} bloquea el certificado.',
      name_mismatch: '{{host}} todavía responde con un certificado para otro nombre.',
      expired: 'El certificado para {{host}} ha caducado. Hemos recibido el aviso y nos estamos ocupando.',
      expiring: 'El certificado para {{host}} caduca pronto y aún no se ha renovado. Nos estamos ocupando.',
      attach_refused:
        'Nuestro proveedor de alojamiento no ha permitido añadir {{host}} por nuestra parte. Nos han avisado y nos estamos ocupando.',
      overdue: 'El certificado para {{host}} sigue sin emitirse después de 48 horas.',
      unknown: 'No se pudo emitir el certificado para {{host}}.',
    },
    certificate_see_row: 'La fila del certificado de abajo indica qué hacer.',
  },
  instructions: {
    title: 'Cómo conectar {{host}}',
    step_provider:
      'Inicia sesión donde se gestiona el DNS de {{zone}} — normalmente la empresa en la que se compró el dominio.',
    step_add: 'Añade cada registro de abajo exactamente como se muestra: su tipo, su nombre y su valor.',
    step_check: 'Guarda y pulsa {{button}}. Además, seguimos comprobándolo por nuestra cuenta.',
    tip_name:
      'La mayoría de los proveedores solo quieren la parte anterior a {{zone}} en el campo del nombre — aquí {{names}}. También se muestra el nombre completo, para los proveedores que lo piden.',
    tip_apex: '@ significa el propio {{zone}}. Algunos proveedores dejan el nombre vacío en su lugar.',
    tip_apex_website:
      'Si {{zone}} ya abre un sitio web, apuntar @ a la tienda quita {{zone}} a ese sitio. Para mantener ahí el sitio web, deja los registros de @ como están — la tienda sigue funcionando en www.{{zone}} — o conecta en su lugar un subdominio como order.{{zone}} para la tienda.',
    tip_existing:
      'Elimina cualquier otro registro A, AAAA o CNAME en {{name}}. Dos registros que apuntan a sitios distintos hacen que la tienda solo cargue a veces.',
    tip_cloudflare:
      'En Cloudflare, configura estos registros como Solo DNS (nube gris). Con el proxy activado, nadie puede ver adónde apuntan y no se puede emitir ningún certificado.',
    tip_locked:
      'Si el proveedor no permite añadir ni cambiar estos registros, puede que el dominio esté bloqueado o que su DNS se gestione en otro sitio. El proveedor puede desbloquearlo o decir dónde se gestiona su DNS.',
  },
  records: {
    title: 'Registros para {{host}}',
  },
  separate_domains: {
    apex: 'Este dominio es solo para la tienda online: la tienda ocupa {{zone}} y www.{{zone}}. Un sitio web necesita otro nombre — un subdominio de {{zone}} o un dominio propio.',
    subdomain: 'Este dominio es solo para la tienda online. Un sitio web puede usar {{zone}} o www.{{zone}}.',
  },
  load_error: 'No se pudo cargar el estado del dominio.',
  no_access: 'Sin acceso al estado del dominio de este restaurante.',
  polling_stopped: 'Esta página ha dejado de actualizarse sola. Pulsa Comprobar de nuevo para actualizarla.',
  buttons: {
    check_again: 'Comprobar de nuevo',
    retry: 'Reintentar',
  },
  toasts: {
    check_started: 'Comprobando los registros. Puede tardar un minuto.',
    check_failed: 'No se pudo iniciar la comprobación. Inténtalo de nuevo.',
    check_too_soon: 'Se acaba de comprobar. Espera un minuto antes de volver a comprobar.',
  },
};
